import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {Button, Col, Container, Row} from 'reactstrap';
import MediaQuery from 'react-responsive';

import MarketDetailPanel from './MarketDetailPanel';
import MarketDetailWheel from './MarketDetailWheel';
import GenericError from "../Common/GenericError";
import MarketCompare from './MarketCompare';
import Header from "./Header"

import device from '../../modules/mediaQuery';
import addCompare from '../../images/add-arrow.svg';
import marketLegend from '../../images/legend_green_square.png';
import compareMarketLegend from '../../images/legend_grey_square.png';
import {
    clearCompareInfo,
    clearComparisonMarketDetails,
    resetCompareMarketsQuarters
} from '../../actions';
import RentCycleConstants from '../../constants/RentCycleConstants';
import { deleteParams } from '../../helpers/Utils';

export class MarketDetail extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isRightPanelVisible: this.props.isRightPanelVisible,
            show: false, // this is used to MarketCompare screen
            showAddCompareButton: !this.props.isRightPanelVisible,
        }
        this.closeRightPanel = this.closeRightPanel.bind(this);
        this.onCloseUrlChange = this.onCloseUrlChange.bind(this);
        this.showRightPanel = this.showRightPanel.bind(this);
        this.hideAddCompareButton = this.hideAddCompareButton.bind(this);
    }

    showModal = () => {
        this.setState({show: true});
    };
    hideModal = () => {
        this.setState({show: false});
    };
    hideAddCompareButton = () => {
        this.setState((state) => ({showAddCompareButton: false}));
    }

    closeRightPanel() {
        // debugger;
        this.setState({
            isRightPanelVisible: false,
            showAddCompareButton: true
        }, () => {
          //  this.props.clearComparisonMarketInfo()
          this.props.clearRightPanel()
        });

       

     //   this.props.resetCompareMarketsQuarters();
      //  this.props.clearCompareInfo('', []); // Clearing the fields related to right panel used to compare- marketname and marketlist, rightpaneldata
      //  this.setState((state) => ({showAddCompareButton: true})); // show Add Compare Button

       // this.props.history.goBack(); // Need to replace this with history.push

        let newUrl = deleteParams('comparemarket');
 
        this.props.history.push(`?${newUrl}`);

    }

    onCloseUrlChange() {
        this.setState({
            isRightPanelVisible: false,
            showAddCompareButton:true
        });

    }


    showRightPanel() {
        this.setState({isRightPanelVisible: true, showAddCompareButton:false}
        );
    }

    componentWillUnmount() {
        let props = this.props;

        props.clearCompareInfoactiveperiod('', [], props.activePeriod);  // Clearing the fields related to right panel used to compare- marketname and marketlist, rightpaneldata

        props.clearComparisonMarketInfo();

    }

    render() {
        return (
            <Container className="main-container">
                <Row className="main-row-detail">
                    <MediaQuery query={device.min.desktop}>
                        <Col><Header/></Col>
                    </MediaQuery>
                </Row>
                {this.props.currentError.Error ? <GenericError msg={this.props.currentError.ErrorMsg}/> :
                    <>
                        <Row className="main-row-data">
                            <MediaQuery query={device.min.desktop}>
                                <Col className="text-left ie-col"><MarketDetailPanel
                                    key={this.state.isRightPanelVisible}
                                    comparisonVisible={this.state.isRightPanelVisible}/></Col>
                                <Col
                                    className={`text-center-detail ie-col ${this.state.isRightPanelVisible ? "" : ""}`}>

                                    {
                                        this.state.showAddCompareButton ? null :
                                            <Row className="market-legend">
                                                <div>
                                                    <Row>
                                                <span><img className="market-legend-img" src={marketLegend}
                                                           alt="market-legend"/></span>
                                                        <span>{this.props.marketselected}</span>
                                                    </Row>
                                                    <Row>
                                                <span><img className="market-legend-img" src={compareMarketLegend}
                                                           alt="compare-market-legend"/></span>
                                                        <span>{this.props.compareMarketSelected}</span>
                                                    </Row>
                                                </div>
                                            </Row>

                                    }

                                    <Row id="addCompare"
                                         className={`market-comparebtn-row-desktop justify-content-end ${this.state.showAddCompareButton ? "" : "hidden"}`}>
                                        {/* <a className={"cursor-pointer add-comparison-button"} style={{height: "30px", width:"220px"}}> */}
                                        <Button className={"cursor-pointer add-comparison-button"} onClick={() => {this.showModal();}}>
                                        <span>
                                            {RentCycleConstants.ADD_COMPARISON_MARKET}
                                        </span>
                                        </Button>
                                        {/* </a> */}
                                    </Row>
                                    <Row><MarketDetailWheel key={this.state.isRightPanelVisible}
                                                            comparisonVisible={this.state.isRightPanelVisible}
                                                            onClosePanel={this.onCloseUrlChange}
                                                            showRightPanel ={this.showRightPanel}
                                                            hideAddCompareButton={this.hideAddCompareButton}/></Row>
                                </Col>
                                {this.state.isRightPanelVisible ?
                                    <Col className="text-left ie-col"><MarketDetailPanel rightPanel={true}
                                                                                         marketCompareQuarters={this.props.marketCompareQuarters}
                                                                                         comparisonVisible={this.state.isRightPanelVisible}
                                                                                         closeButtonVisible={true}
                                                                                         onClosePanel={this.closeRightPanel}/></Col> : null}
                            </MediaQuery>
                        </Row>
                        <MarketCompare show={this.state.show} onClose={this.hideModal}
                                       showRightPanel={this.showRightPanel}
                                       hideAddCompareButton={this.hideAddCompareButton}/>
                    </>
                }
            </Container>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        currentError: state.errorState,
        marketquarters: state.comparisonMarkets.comparisonMarkets[0] ? state.comparisonMarkets.comparisonMarkets[0].marketDetails : [],
        marketselected: state.comparisonMarkets.comparisonMarkets[0] ? state.comparisonMarkets.comparisonMarkets[0].market : '',
        marketCompareQuarters: state.comparisonMarkets.comparisonMarkets[1] ? state.comparisonMarkets.comparisonMarkets[1].marketDetails : [],
        compareMarketSelected: state.comparisonMarkets.comparisonMarkets[1] ? state.comparisonMarkets.comparisonMarkets[1].market : '',
        comparemarketslist: state.comparemarketslist,
        marketInfo: state.comparisonMarkets,
        activePeriod: state.activePeriod,
        selectedWheelPosition: state.selectedWheelPosition.selectedWheelPosition,
        selectedSliderPosition: state.selected,
        isRightPanelVisible: state.comparisonMarkets.isRightPanelVisible
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        resetCompareMarketsQuarters: () => {
            dispatch(resetCompareMarketsQuarters())
        },
        clearCompareInfo: (clearText, clearArray) => {
            dispatch(clearCompareInfo(clearText, clearArray))
        },
        clearComparisonMarketInfo: () => {
            dispatch(clearComparisonMarketDetails())
        },
        clearCompareInfoactiveperiod: (clearText, clearArray, activePeriod) => {
            dispatch(clearCompareInfo(clearText, clearArray))
            dispatch({type: "FETCH_PERIODS", payload: activePeriod});
        },
        clearRightPanel: () => {
            dispatch({type:"CLEAR_COMPARISON_MARKET_SELECTED"});
           // dispatch({type:"COMPARE_MARKET_DESELECTED"});
        }
    }
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(MarketDetail)
)